import { restClient } from "libs/restClient";
import requesTypes from "dictionaries/ReqTypes";
import { downloadFile } from "helpers/Uploads";
import { notifyMessages } from "helpers/NotifyHelper";
import { docStatuses } from "helpers/DocumentStatus";
import { requestStatuses, isRequesttWithdrawn } from "helpers/RequestHelper";
import { getRequestBackbone } from "helpers/RequestBackbone";
import * as arg from "helpers/ArgsHelper";
import { testStatuses } from "helpers/RequestTestsHelper";
import {
  getInputValue,
  getCheckboxGroupValue,
  setSelectedGroupValue,
  getFileData,
  setManualData,
  updateDocumentTitle,
  updateDocumentFile
} from "libs/form";
import * as actions from "actions/types";

export function fetchRequest(id) {
  const url = `/requests/${id}/details`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.FETCH_REQUEST,
    payload
  };
}

export function handleInputChange(event) {
  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: getInputValue(event)
  };
}

export function toggleCheckbox(event) {
  const { id, checked } = event.target;
  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: {
      field: id,
      value: checked
    }
  };
}

export function handleCheckboxGroupChange(values, index, event) {
  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: getCheckboxGroupValue(index, event, values)
  };
}

export function handleSelectGroupChange(id, values, event) {
  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: setSelectedGroupValue(id, event, values)
  };
}

export function approveUserManual(modelId, decision) {
  const newDocStatus =
    decision === true
      ? docStatuses.approved.id
      : decision === false
      ? docStatuses.rejected.id
      : docStatuses.pending.id;

  const url = `/devicemodels/${modelId}/manual`;
  const body = arg.prepareDocumentApproveArgs(newDocStatus);

  const payload = restClient
    .put(url, body)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPDATE_USERS_MANUAL,
    payload
  };
}

export function handleFileChange(fileData, event) {
  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: {
      field: event.target.id,
      value: getFileData(event, fileData)
    }
  };
}

export function handleFileUpload(fileData) {
  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: setManualData(fileData)
  };
}

export function handleDocTitleChange(index, documents, event) {
  const { id, name, value } = event.target;
  const field = id || name;

  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: {
      field,
      value: updateDocumentTitle(index, value, documents)
    }
  };
}

export function handleDocFileChange(index, documents, event) {
  const { id, name, files } = event.target;
  const field = id || name;
  const fileContent = files[0];

  return {
    type: actions.CHANGE_REQUEST_FIELD,
    payload: {
      field,
      value: updateDocumentFile(index, fileContent, documents)
    }
  };
}

export function saveRequest(callback = () => {}) {
  const req = { formSaved: true, isLoading: true };

  callback();

  return {
    type: actions.SAVE_REQUEST,
    payload: req
  };
}

export function returnToEditRequest() {
  return {
    type: actions.RETURN_TO_EDIT_REQUEST,
    payload: { formSaved: false, isLoading: false }
  };
}

export function clearRequest() {
  return { type: actions.CLEAR_REQUEST };
}

export function makeLabDecision(decision, request) {
  const statusId =
    decision === true
      ? testStatuses.accepted
      : decision === false
      ? testStatuses.rejected
      : testStatuses.pending;

  const url = `/requests/${request.id}/requesttests?statusid=${statusId}`;

  return {
    type: actions.MAKE_LAB_DECISION,
    payload: restClient.put(url)
  };
}

export function approveRequest(requestId, approved) {
  const newReqStatus =
    approved === true
      ? requestStatuses.approved
      : approved === false
      ? requestStatuses.requestWithdrawn
      : null;

  if (!newReqStatus) return Promise.reject(notifyMessages.cantSubmitRequest);

  const url = `/requests/${requestId}`;
  const body = arg.prepareRequestApproveArgs(newReqStatus);

  const payload = restClient
    .put(url, body)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPDATE_REQUEST_STATUS,
    payload
  };
}

export function createInitialRequest(manufacturer = "") {
  const requestBackbone = getRequestBackbone();
  return {
    type: actions.NEW_REQUEST_INIT,
    payload: {
      ...requestBackbone,
      model: { vendor: { name: manufacturer } },
      type: requesTypes.initial
    }
  };
}

export function createEcoRequest(manufacturer = "") {
  const requestBackbone = getRequestBackbone();
  return {
    type: actions.NEW_REQUEST_INIT,
    payload: { ...requestBackbone, manufacturer, type: requesTypes.eco }
  };
}

export function createRebrandRequest(manufacturer = "") {
  const requestBackbone = getRequestBackbone();
  return {
    type: actions.NEW_REQUEST_INIT,
    payload: { ...requestBackbone, manufacturer, type: requesTypes.rebrand }
  };
}

export function updateDeviceModel(modelId, deviceInfo) {
  const body = {
    args: { ...deviceInfo }
  };

  const payload = restClient
    .put(`/devicemodels/${modelId}`, JSON.stringify(body))
    .then(response => {
      return response;
    })
    .catch(err => {
      // return err;
    });

  return {
    type: actions.UPDATE_DEVICE_MODEL,
    payload
  };
}

export const fetchPocs = (companyId = null) => async dispatch => {
  try {
    // companyid uses in case if someone want to fetch data for different company
    // (e.g. Staff viewing Vendor's request)
    const urlTail = companyId ? `&where=companyid=${companyId}` : "";
    const url = `/pocs?page=0${urlTail}`;
    const response = await restClient.get(url);

    dispatch({ type: actions.FETCH_POCS, payload: response.data.data });
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantFetchPocs
    });
  }
};

export const createNewPoc = (
  pocInfo,
  companyId,
  callback
) => async dispatch => {
  try {
    const reqBody = arg.preparePocInfoArgs(pocInfo, companyId);
    const response = await restClient.post("pocs", JSON.stringify(reqBody));

    dispatch({ type: actions.CREATE_NEW_POC, payload: response.data.data.id });

    callback();
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantCreatePoc
    });
  }
};

export const createNewBillingPoc = (
  pocInfo,
  companyId,
  callback,
  errCallback
) => async dispatch => {
  try {
    const reqBody = arg.prepareBillingPocArgs(pocInfo, companyId);
    const response = await restClient.post("pocs", JSON.stringify(reqBody));

    dispatch({
      type: actions.CREATE_NEW_BILLING_POC,
      payload: response.data.data.id
    });
    callback();
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantCreatePoc
    });
    errCallback();
  }
};

export const createNewBillingAddress = (
  formData,
  companyId,
  callback,
  errCallback
) => async dispatch => {
  try {
    const reqBody = arg.prepareBillingAddressArgs(formData, companyId);
    const response = await restClient.post(
      "addresses",
      JSON.stringify(reqBody)
    );

    dispatch({
      type: actions.CREATE_NEW_BILLING_ADDRESS,
      payload: response.data.data.id
    });

    callback();
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantCreateBillingAddress
    });
    errCallback();
  }
};

export function usersManualDownload({ tn, model, usersManual }) {
  // file name pattern: CBRSA00000_ProductDescription.extension
  // e.g. CBRSA00345_ProductDescription.pdf
  const fileName = `${tn}_ProductDescription.${usersManual.document.extension}`;

  const url = `/devicemodels/${model.id}/manual?download=true`;
  const payload = restClient
    .get(url, { responseType: "blob" })
    .then(response => {
      downloadFile(response.data, fileName);
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.USERS_MANUAL_DOWNLOAD,
    payload
  };
}

export function getUsersManualInfo(modelId) {
  const url = `/devicemodels/${modelId}/manual`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.GET_USERS_MANUAL_INFO,
    payload
  };
}

export function documentDownload(document, request) {
  // file name pattern: CBRSA00000_SupportDoc_Slot.extension
  // e.g. CBRSA00345_SupportDoc_3.pdf
  const fileName = `${request.tn}_SupportDoc_${document.slot}.${document.document.extension}`;

  const url = `/requests/${request.id}/documents/${document.slot}?download=true`;
  const payload = restClient
    .get(url, { responseType: "blob" })
    .then(response => {
      downloadFile(response.data, fileName);
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DOCUMENT_DOWNLOAD,
    payload
  };
}

export function updatePublicationOptions(
  { id, certificationOption },
  callback
) {
  const reqBody = {
    args: {
      publishdetails: certificationOption ? 1 : 0
    }
  };
  const url = `/requests/${id}`;
  const payload = restClient
    .put(url, JSON.stringify(reqBody))
    .then(response => {
      callback();
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.UPDATE_PUBLICATION_OPTIONS,
    payload
  };
}

export function deleteDocument(requestId, slot) {
  const url = `/requests/${requestId}/documents/${slot}?download=true`;
  const payload = restClient
    .delete(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DELETE_DOCUMENT,
    payload
  };
}

export const updateRequest = ({ id, ...rest }) => async dispatch => {
  try {
    const reqBody = {
      args: { ...rest }
    };

    const payload = await restClient.put(
      `/requests/${id}`,
      JSON.stringify(reqBody)
    );
    dispatch({ type: actions.UPDATE_REQUEST, payload });
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.requestUpdatedSuccessfully
    });
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantUpdateRequest
    });
  }
};

export function cleanPocInfo() {
  return {
    type: actions.CLEAN_POC_INFO,
    payload: {
      pocId: "",
      pocFirstName: "",
      pocLastName: "",
      pocEmail: "",
      pocPhone: ""
    }
  };
}

export function cleanBillingPocInfo() {
  return {
    type: actions.CLEAN_POC_INFO,
    payload: {
      billingPocId: "",
      billingPocFirstName: "",
      billingPocLastName: "",
      billingPocEmail: "",
      billingPocPhone: ""
    }
  };
}

export function cleanBillingAddressInfo() {
  return {
    type: actions.CLEAN_POC_INFO,
    payload: {
      billingAddressId: "",
      billingAddressName: "",
      billingAddressLine1: "",
      billingAddressLine2: "",
      billingOrderNum: ""
    }
  };
}

export const submitInitialRequest = (
  request,
  wizardCallback
) => async dispatch => {
  const modelArgs = arg.prepareModelArgs(request);
  const billingArgs = arg.prepareBillingArgs(request);

  let createdModelId = null;
  let createdBillingId = null;
  let createdRequestId = null;

  // STEP 1: create new device model
  try {
    const modelResponse = await restClient.post(
      "/devicemodels",
      JSON.stringify(modelArgs)
    );

    createdModelId = modelResponse.data.data.id;
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantSubmitRequest
    });
  }

  // STEP 2: create new billing entry
  try {
    const billingResponse = await restClient.post(
      "/billings",
      JSON.stringify(billingArgs)
    );

    createdBillingId = billingResponse.data.data.id;
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantCreateBillingEntry
    });
  }

  // STEP 3: create new request
  try {
    const args = arg.prepareRequestArgs(
      request,
      createdBillingId,
      createdModelId
    );
    const response = await restClient.post("/requests", JSON.stringify(args));
    createdRequestId = response.data.data.id;
  } catch (e) {
    // we have to delete created device model due to this error
    const url = `/devicemodels/${createdModelId}`;
    await restClient.delete(url);

    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantSubmitRequest
    });
  }

  // STEP 4: sign license agreement
  try {
    if (request.agreementAccepted) {
      const url = `/devicemodels/${createdModelId}/licenseagreements`;
      await restClient.post(url);
    }
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantSignAgreement
    });
  }

  // STEP 5: call submission wizard callback
  wizardCallback();

  // STEP 6: update redux store and finalize submission
  dispatch({
    type: actions.SUBMIT_INITIAL_REQUEST,
    payload: {
      newId: createdRequestId,
      deviceModelId: createdModelId,
      agreementAccepted: request.agreementAccepted
    }
  });
};

export const submitEcoRequest = (request, wizardCallback) => async dispatch => {
  let createdBillingId = null;

  // STEP 1: create new billing entry
  const billingArgs = arg.prepareBillingArgs(request);

  try {
    const billingResponse = await restClient.post(
      "/billings",
      JSON.stringify(billingArgs)
    );

    createdBillingId = billingResponse.data.data.id;
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantCreateBillingEntry
    });
  }

  // STEP 2: create new ECO request
  const args = arg.prepareEcoRequestArgs(request, createdBillingId);

  try {
    const response = await restClient.post("/requests", JSON.stringify(args));
    const { id, devicemodelid, ...rest } = response.data.data;

    // call submission wizard callback
    wizardCallback();

    // dispatch submit action
    dispatch({
      type: actions.SUBMIT_ECO_REQUEST,
      payload: {
        ...rest,
        newId: id,
        deviceModelId: devicemodelid
      }
    });
  } catch (e) {
    dispatch({
      type: actions.SHOW_NOTICE,
      payload: notifyMessages.cantSubmitRequest
    });
  }
};

export function signAgreement(modelId, needToSign) {
  if (!needToSign) return Promise.resolve(true);

  const url = `/devicemodels/${modelId}/licenseagreements`;
  return restClient
    .post(url)
    .then(response => {
      if (response.status === 201) {
        return Promise.resolve(true);
      }
      return response;
    })
    .catch(() => {
      return Promise.reject(notifyMessages.cantSignAgreement);
    });
}

export function withdrawRequest(id, reason = "") {
  const args = arg.prepareWithdrawnArgs(reason);
  const payload = restClient
    .put(`/requests/${id}`, JSON.stringify(args))
    .then(response => {
      if (response.status === 200) {
        return Promise.resolve(true);
      }
      return Promise.reject(notifyMessages.cantWithdrawRequest);
    })
    .catch(err => {
      return Promise.reject(notifyMessages.cantWithdrawRequest);
    });

  return {
    type: actions.WITHDRAW_REQUEST,
    payload
  };
}

export function unwithdrawRequest(id, prevStatusId) {
  // if prev status is `Withdrawn`, change it to `Pending`
  const newStatus = isRequesttWithdrawn(prevStatusId)
    ? requestStatuses.pending
    : prevStatusId;
  const args = arg.prepareUnwithdrawnArgs(newStatus);
  const payload = restClient
    .put(`/requests/${id}`, JSON.stringify(args))
    .then(response => {
      if (response.status === 200) {
        return Promise.resolve(true);
      }
      return Promise.reject(notifyMessages.cantUnwithdrawRequest);
    })
    .catch(err => {
      return Promise.reject(notifyMessages.cantUnwithdrawRequest);
    });

  return {
    type: actions.UNWITHDRAW_REQUEST,
    payload
  };
}

export function searchRequest(transactionNumber) {
  const url = `/requests?where=transactionnumber LIKE ${transactionNumber}`;
  const payload = restClient
    .get(url)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.SEARCH_REQUEST,
    payload
  };
}

export function setValidationStatus(validationStatus) {
  return {
    type: actions.SET_VALIDATION_STATUS,
    payload: validationStatus
  };
}

export function toggleEditMode() {
  return {
    type: actions.TOGGLE_REQUEST_EDIT_MODE,
    payload: null
  };
}

export function invoiceDownload({ tn, invoice }) {
  // file name pattern: CBRSA00000_Invoice.pdf
  // e.g. CBRSA00345_Invoice.pdf
  const fileName = `${tn}_Invoice.pdf`;

  const url = `/invoices/${invoice.id}?pdf=true`;
  const payload = restClient
    .get(url, { responseType: "blob" })
    .then(response => {
      downloadFile(response.data, fileName);
      return response;
    })
    .catch(err => {
      return err;
    });

  return {
    type: actions.DOCUMENT_DOWNLOAD,
    payload
  };
}



// WEBPACK FOOTER //
// ./src/actions/request.js